import React from 'react'
import OffresSection from './components/OffresSection'
import SubscriptionPlansSection from './components/SubscriptionPlansSection'

export default function CompanyOffers() {
 /*  const { t } = useTranslation() */

 /*  const data = [
    {
      id: 1,
      title: `${t('stickyNav.companyService')}`,
      list: [
        {
          text: `${t('stickyNav.recruitment')}`,
        },
        {
          text: `${t('stickyNav.searchOptimization')}`,
        },
      ],
      button: `${t('button.discuss')}`,
    },
  ] */

  return (
    <div>
      <main>
        <SubscriptionPlansSection />
      </main>
    </div>
  )
}
